import { render } from "./Fulfill.vue?vue&type=template&id=3016b3a3"
import script from "./Fulfill.vue?vue&type=script&lang=js"
export * from "./Fulfill.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__